<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
    <div class="section">
      <div class="header" *ngIf="!edit_heading">
         {{'ADDDRIVER.driver' | translate}}
        <i class="material-icons" (click)="closeDialog();">clear</i>
      </div>
      <div class="header" *ngIf="edit_heading">
        {{'EDITDRIVER.title' | translate}}
       <i class="material-icons" (click)="closeDialog();">clear</i>
     </div>
      <div class="addSection">
        <div class="form">
  
          <div class="formElement">
            <div class="formLabel">
              {{'ADDDRIVER.driverName' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="newDriverData.name" type="text" />
            </div>
            <div class="check">
              <mat-checkbox [(ngModel)]='newDriverData.has_smart_phone'>{{'ADDDRIVER.hasSmartPhone' | translate}}</mat-checkbox>
          </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'ADDDRIVER.mobile' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="newDriverData.mobile" type="text" />
            </div>
            <!-- <div class="check">
              <mat-checkbox [(ngModel)]='newDriverData.ws_opt_in'> <img class ="whatsapp" src="assets/whatsappround.svg" alt=""> {{'ADDDRIVER.optIn' | translate}}</mat-checkbox>
          </div> -->
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'ADDDRIVER.license' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
              <small class="smallLink" *ngIf="showVerifyLinks" (click)="openVerifyModal('https://parivahan.gov.in/rcdlstatus/?pur_cd=101')">({{'ADDDRIVER.verifyLicense' | translate}})</small>

            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="newDriverData.licence.no" type="text" [disabled]="editFlag" />
            </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'ADDDRIVER.licenseExpiryDate' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <div class="formInput">
              <input type="text" class="form-input" name="expiryDate" [matDatepicker]="picker" [(ngModel)]="expiryDate" (click)="picker.open()" />
              <mat-datepicker #picker (closed)="setExpiryDate(expiryDate, 'change')"></mat-datepicker>
            </div>
          </div>
  
          <div class="formElement">
            <div class="formLabel">
              {{'ADDDRIVER.driverType' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <div class="formInput">
              <mat-select class="form-input" [(ngModel)]="newDriverData.driver_type">
                <mat-option *ngFor="let type of driverType" [value]="type.val" (onSelectionChange)="newDriverData.driver_type = type.val">
                    {{type.name}}
                </mat-option>
              </mat-select>
            </div>
          </div>

          <!-- <div class="formElement">
            <div class="formLabel">
              Location (City)
            </div>
            <div class="formInput">
              <mat-select class="form-input" [(ngModel)]="newDriverData.city">
                <mat-option *ngFor="let city of cityArray" [value]="city._id" (onSelectionChange)="newDriverData.city = city._id">
                    {{city.name}}
                </mat-option>
              </mat-select>
            </div>
          </div> -->
  
          <div class="formElement" *ngIf="!editFlag">
            <div class="formLabel">
              {{'ADDDRIVER.password' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="newDriverData.password" type="password" />
            </div>
          </div>

          <div class="formElement" *ngIf="!editFlag">
            <div class="formLabel">
              {{'ADDDRIVER.confirm' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <div class="formInput">
              <input class="form-input" [(ngModel)]="confirmPassword" type="password" />
            </div>
          </div>
  
          <!-- <div class="formElement">
            <div class="formLabel">
              Resident ID
            </div>
            <div class="formInput">
              <input class="form-input"  type="text" />
            </div>
          </div> -->
  
          <!-- <div class="formElement">
            <div class="formLabel">
              Resident Image
            </div>
            <div class="formInput">
              <input class="form-input" type="file" />
            </div>
          </div> -->

          <div class="formElement">
            <div class="formLabel">
              {{'ADDDRIVER.driverAddress' | translate}} <sup style="color: #E54131; font-weight: 900;">*</sup>
            </div>
            <div class="formInput">
              <input class="form-input" id="addressSearch" [(ngModel)]="address" type="text" />
            </div>
          </div>
          <div class="submitButton" (click)="submit();">
            <div class="button" *ngIf="!editFlag">{{'ADDDRIVER.submit' | translate}}</div>
            <div class="button" *ngIf="editFlag">{{'ADDDRIVER.update' | translate}}</div>
          </div>
        </div>
        <div class="map" id="pathMap"></div>
      </div>
    </div>
  </div>